import { Dropdown, SelectOption } from "components/dropdown/Dropdown";
import { useField } from "formik";
import { options } from "yargs";
import {
  ParsedWorkflowItem,
  ReferenceData,
  WorkflowBuilderErrors,
  WorkflowReferenceDataNames,
} from "../WorkflowBuilderPage";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";

import addButton from "assets/Icon_Btn_01.png";
import {
  checkExistingReferenceDataValueIds,
  checkExistingValueIds,
  getExistingValueFromParsedData,
  getMaxNumberInArray,
  addWorkflowBuilderReferenceData,
  updateWorkflowBuilderValue,
  changeWorkflowBuilderReferenceData,
  getAllOrderNumbers,
} from "./WorkflowItem";
import { classPrivateMethod } from "@babel/types";
import _ from "lodash";
import {
  MultiDropdown,
  MultiSelectOption,
} from "components/dropdown/MultiDropdown";
import { ValueType } from "react-select";

import deleteIcon from "assets/delete_icon.png";
import { Modal } from "components/modal/Modal";
import editIcon from "assets/edit_icon.png";

import minimiseIcon from "assets/Icon_Form_Search_02.png";
import { customUseOnClickOutside } from "components/helpers/CustomFieldRenderers/SearchListFieldRenderer/SearchListRenderer";

export type EditApprovalDecisionProps = {
  showApprovalEditBox: boolean;
  setShowApprovalEditBox: React.Dispatch<SetStateAction<boolean>>;
  deleteApproval: () => void;
};
export const EditApprovalDecision: React.FC<EditApprovalDecisionProps> = ({
  showApprovalEditBox,
  setShowApprovalEditBox,
  deleteApproval,
}) => {
  const [showDeletePopUp, setShowDeletePopUp] = useState<boolean>(false);

  const confirmDelete = () => {
    deleteApproval();
    setShowDeletePopUp(false);
    setShowApprovalEditBox(false);
  };
  return (
    <>
      <div className="EditApprovalDecision TriggerContainer">
        <div className="Btn" onClick={() => setShowDeletePopUp(true)}>
          <div className="Text">Delete approval decision</div>
        </div>

        <img
          src={minimiseIcon}
          className="MinimiseIcon"
          alt="Close edit approval decision"
          onClick={() => setShowApprovalEditBox(false)}
        />
      </div>

      {showDeletePopUp && (
        <Modal
          open={showDeletePopUp}
          closeModal={() => {
            setShowDeletePopUp(false);
          }}
          title={`Delete approval decision`}
          actionButton={
            <button className="Btn" onClick={confirmDelete}>
              Yes
            </button>
          }
          clearUnderlay={true}
          extraClassNames="DeleteWorkflowAction"
        >
          <div className="Text">
            Are you sure you want to delete this approval decision?
          </div>

          <div className="Text">
            All related decision outcomes will be deleted as well.
          </div>
        </Modal>
      )}
    </>
  );
};
interface Props {
  fieldName: string;
  selectOptions: SelectOption[];
  type: "trigger" | "action";
  itemData: any;
  parsedData: ParsedWorkflowItem | null;
  setParsedData: React.Dispatch<SetStateAction<ParsedWorkflowItem | null>>;
  referenceData: ReferenceData | null;
  setReferenceData: React.Dispatch<SetStateAction<ReferenceData | null>>;
  uniqueId: string;
  contactTypes: SelectOption[];
  userPools: SelectOption[];
  deleteApprovalOutcomes: (
    approvalId: number,
    approvalOutcomeIds: number[]
  ) => void;
  workflowBuilderErrors: WorkflowBuilderErrors;
  showApprovalEditBox: boolean;
  setShowApprovalEditBox: React.Dispatch<SetStateAction<boolean>>;
}

type DeleteApprovalProps = {
  approvalId: number;
  approvalOutcomeIds: number[];
  deleteApprovalOutcomes: (
    approvalId: number,
    approvalOutcomeIds: number[]
  ) => void;
  type?: "icon" | "button";
};

const DeleteApproval: React.FC<DeleteApprovalProps> = ({
  approvalId,
  approvalOutcomeIds,
  deleteApprovalOutcomes,
  type = "icon",
}) => {
  const [showDeletePopUp, setShowDeletePopUp] = useState<boolean>(false);

  const confirmDelete = () => {
    deleteApprovalOutcomes(approvalId, approvalOutcomeIds);
    setShowDeletePopUp(false);
  };

  const bind = customUseOnClickOutside(() => {
    setShowDeletePopUp(false);
  }, true);

  return (
    <div className="DeleteApprovalOutcomeContainer">
      {type === "icon" && (
        <div
          className="DeleteBtn DeleteApprovalOutcomeIcon"
          onClick={() => setShowDeletePopUp(true)}
        >
          <img src={deleteIcon} alt="Delete action" className="DeleteIcon" />
        </div>
      )}

      {type === "button" && (
        <button
          type="button"
          className="DeleteBtn DeleteApprovalOutcomeButton"
          onClick={() => setShowDeletePopUp(true)}
        >
          Delete all approval outcomes
        </button>
      )}

      {showDeletePopUp && (
        <Modal
          open={showDeletePopUp}
          closeModal={() => {
            setShowDeletePopUp(false);
          }}
          title={`Delete approval outcome`}
          actionButton={
            <button className="Btn" onClick={confirmDelete}>
              Yes
            </button>
          }
          clearUnderlay={true}
          extraClassNames="DeleteWorkflowApprovalOutcome"
        >
          <div className="Text">
            Are you sure you want to delete this approval outcome?
          </div>
        </Modal>
      )}
    </div>
  );
};

const ApprovalDecision: React.FC<Props> = ({
  fieldName,
  selectOptions,
  type,
  itemData,
  parsedData,
  setParsedData,
  referenceData,
  setReferenceData,
  uniqueId,
  contactTypes,
  userPools,
  deleteApprovalOutcomes,
  workflowBuilderErrors,
  showApprovalEditBox,
  setShowApprovalEditBox,
}) => {
  const [approvalData, setApprovalData] = useState<any>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [approvalOutcomes, setApprovalOutcomes] = useState<any | null>(null);
  const [emailNotifications, setEmailNotifications] = useState<boolean>(false);
  const [relevantErrors, setRelevantErrors] = useState<string[] | null>(null);

  useEffect(() => {
    if (
      itemData &&
      itemData.nodeApprovalId &&
      workflowBuilderErrors &&
      workflowBuilderErrors.approvals &&
      workflowBuilderErrors.approvals.hasOwnProperty(itemData.nodeApprovalId)
    ) {
      const tempErrors =
        workflowBuilderErrors.approvals[itemData.nodeApprovalId];

      if (Array.isArray(tempErrors) && tempErrors.length > 0) {
        setRelevantErrors(tempErrors);
      } else {
        setRelevantErrors(null);
      }
    } else {
      setRelevantErrors(null);
    }
  }, [workflowBuilderErrors]);

  const handleDropdownChangeMulti = (
    options: SelectOption[],
    fieldName: string
  ) => {
    const optionIds = options ? options.map(item => item.value) : null;

    const newParsedData = updateWorkflowBuilderValue(
      parsedData,
      uniqueId,
      fieldName,
      optionIds,
      "replace"
    );

    setParsedData(newParsedData);

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.APPROVALS,
      "workflowApprovalsID",
      itemData.nodeApprovalId ?? null,

      fieldName,
      optionIds,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  const handleDropdownChangeSingle = (
    option: SelectOption,
    fieldName: string
  ) => {
    const optionId = option ? option.value : null;

    const newParsedData = updateWorkflowBuilderValue(
      parsedData,
      uniqueId,
      fieldName,
      optionId,
      "replace"
    );

    setParsedData(newParsedData);

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.APPROVALS,
      "workflowApprovalsID",
      itemData.nodeApprovalId ?? null,

      fieldName,
      optionId,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  useEffect(() => {
    if (
      approvalData &&
      approvalData.bEmailNotifications
    ) {
      setEmailNotifications(true);
    } else {
      setEmailNotifications(false);
    }

    if (
      approvalData &&
      approvalData.childrenWorkflowApprovalOutcomeIDs &&
      Array.isArray(approvalData.childrenWorkflowApprovalOutcomeIDs)
    ) {
      let tempApprovalOutcomes: any[] = [];

      approvalData.childrenWorkflowApprovalOutcomeIDs.forEach(
        (approvalOutcomeId: any, idx: number) => {
          const approvalOutcomesData =
            referenceData &&
            referenceData.approvalOutcomes &&
            Array.isArray(referenceData.approvalOutcomes)
              ? referenceData.approvalOutcomes
              : null;

          const match =
            approvalOutcomesData && typeof approvalOutcomesData == "object"
              ? approvalOutcomesData.filter(
                  (item: any) =>
                    `${item.workflowApprovalOutcomesID}` ===
                    `${approvalOutcomeId}`
                )
              : null;

          let itemApprovalOutcomesData: any = null;
          if (Array.isArray(match) && match.length === 1) {
            itemApprovalOutcomesData = match[0];

            tempApprovalOutcomes.push(match[0]);
          }
        }
      );

      setApprovalOutcomes(tempApprovalOutcomes);
    } else {
      setApprovalOutcomes(null);
    }
  }, [approvalData]);

  const handleSave = () => {};

  const messageOnBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    const newParsedData = updateWorkflowBuilderValue(
      parsedData,
      uniqueId,
      "message",
      message
    );

    setParsedData(newParsedData);

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.APPROVALS,
      "workflowApprovalsID",
      itemData.nodeApprovalId ?? null,

      "message",
      message,
      "replace"
    );

    setReferenceData(newReferenceData);
  };
  const decisionOutcomeOnBlur = (idx: number) => {
    const newParsedData = updateWorkflowBuilderValue(
      parsedData,
      `${uniqueId}, ${idx}`,
      "workflowApprovalOutcomesName",
      approvalOutcomes[idx].workflowApprovalOutcomesName
    );

    let newReferenceData = _.cloneDeep(referenceData);

    const approvalOutcomeId =
      approvalOutcomes &&
      approvalOutcomes[idx] &&
      approvalOutcomes[idx].workflowApprovalOutcomesID
        ? approvalOutcomes[idx].workflowApprovalOutcomesID
        : null;

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.APPROVAL_OUTCOMES,
      "workflowApprovalOutcomesID",
      approvalOutcomeId ?? null,
      "workflowApprovalOutcomesName",
      approvalOutcomes[idx].workflowApprovalOutcomesName,
      "replace"
    );

    setReferenceData(newReferenceData);

    setParsedData(newParsedData);
  };

  useEffect(() => {
    const approvalDataId =
      itemData && itemData.hasOwnProperty("nodeApprovalId")
        ? itemData.nodeApprovalId
        : null;

    if (
      approvalDataId !== null &&
      referenceData &&
      referenceData.approvals &&
      Array.isArray(referenceData.approvals)
    ) {
      const matches = referenceData.approvals.filter(
        item => item.workflowApprovalsID === approvalDataId
      );

      if (matches && matches.length === 1) {
        setApprovalData(matches[0]);

        if (matches[0] && matches[0].message) {
          setMessage(matches[0].message);
        }
      }
    }
  }, [itemData, approvalData, referenceData]);

  const handleAddDecisionOutcome = () => {
    const workflowApprovalId = itemData.nodeApprovalId ?? null;

    let approvalOrderNumber: any = null;
    if (
      workflowApprovalId &&
      referenceData &&
      referenceData.approvals &&
      Array.isArray(referenceData.approvals) &&
      referenceData.approvals.length > 0
    ) {
      const match = referenceData.approvals.filter(
        item => item.workflowApprovalsID === workflowApprovalId
      );

      if (match.length === 1 && match[0].hasOwnProperty("orderNumber")) {
        approvalOrderNumber = match[0].orderNumber;
      }
    }
    let tempApprovalOutcomes =
      approvalOutcomes && Array.isArray(approvalOutcomes)
        ? [...approvalOutcomes]
        : [];

    const allOrderNumbers = getAllOrderNumbers(parsedData, referenceData);

    const maxOrderNumber = getMaxNumberInArray(allOrderNumbers);

    const newOrderNumber =
      typeof maxOrderNumber === "number" && isFinite(maxOrderNumber)
        ? maxOrderNumber + 1
        : 1;

    const allApprovalOutcomeIds = checkExistingReferenceDataValueIds(
      referenceData,
      WorkflowReferenceDataNames.APPROVAL_OUTCOMES,
      "workflowApprovalOutcomesID"
    );

    const maxApprovalOutcomeId = getMaxNumberInArray(allApprovalOutcomeIds);

    const newApprovalOutcomeId =
      typeof maxApprovalOutcomeId === "number" && isFinite(maxApprovalOutcomeId)
        ? maxApprovalOutcomeId + 1
        : 1;

    const allApprovalIds = checkExistingReferenceDataValueIds(
      referenceData,
      WorkflowReferenceDataNames.APPROVALS,
      "workflowApprovalsID"
    );

    const maxApprovalId = getMaxNumberInArray(allApprovalIds);

    const newApprovalId =
      typeof maxApprovalId === "number" && isFinite(maxApprovalId)
        ? maxApprovalId + 1
        : 1;

    if (
      typeof newOrderNumber === "number" &&
      typeof newApprovalOutcomeId === "number" &&
      typeof newApprovalId === "number"
    ) {
      // Set decision data in parsedData:
      let blankDecision = { ...itemData };

      Object.keys(blankDecision).forEach(item => {
        blankDecision[item] = null;
      });

      blankDecision.parentOrderNumber = approvalOrderNumber ?? null;

      blankDecision.orderNumber = newOrderNumber;
      blankDecision.workflowApprovalOutcomesID = newApprovalOutcomeId;
      blankDecision.workflowApprovalOutcomesName = null;

      tempApprovalOutcomes.push(blankDecision);

      let newParsedData = _.cloneDeep(parsedData);

      newParsedData = updateWorkflowBuilderValue(
        newParsedData,
        `${uniqueId}`,
        "childElements",
        blankDecision,
        "append"
      );

      newParsedData = updateWorkflowBuilderValue(
        newParsedData,
        `${uniqueId}`,
        "childrenWorkflowApprovalOutcomeIDs",
        newApprovalOutcomeId,
        "append"
      );

      let newReferenceData = _.cloneDeep(referenceData);

      newReferenceData = changeWorkflowBuilderReferenceData(
        newReferenceData,
        WorkflowReferenceDataNames.APPROVALS,
        "workflowApprovalsID",
        itemData.nodeApprovalId ?? null,

        "childrenWorkflowApprovalOutcomeIDs",
        newApprovalOutcomeId,
        "append"
      );

      // Set approval outcome data in reference data:

      let blankApprovalOutcome: any = {
        childWorkflowActionID: null,
        childWorkflowApprovalID: null,
        orderNumber: newOrderNumber,
        parentOrderNumber: approvalOrderNumber ?? null,

        workflowApprovalOutcomesID: newApprovalOutcomeId,
        workflowApprovalOutcomesName: null,
        bNewlyCreated: true, // So we can delete the id we assign here just before we post to the endpoint
        bReasonCode: false,
      };
      if (
        referenceData &&
        referenceData.approvalOutcomes &&
        Array.isArray(referenceData.approvalOutcomes) &&
        referenceData.approvalOutcomes.length > 0 &&
        typeof referenceData.approvalOutcomes[0] === "object"
      ) {
        let temp = { ...referenceData.approvalOutcomes[0] };

        Object.keys(temp).forEach(i => (temp[i] = null));

        temp.parentOrderNumber = approvalOrderNumber ?? null;

        temp.orderNumber = newOrderNumber;

        temp.workflowApprovalOutcomesID = newApprovalOutcomeId;
        temp.bNewlyCreated = true;
        temp.bReasonCode = false;

        blankApprovalOutcome = temp;
      }

      newReferenceData = addWorkflowBuilderReferenceData(
        newReferenceData,
        WorkflowReferenceDataNames.APPROVAL_OUTCOMES,
        blankApprovalOutcome
      );

      setParsedData(newParsedData);

      setReferenceData(newReferenceData);
    }
  };

  const handleBooleanChange = (fieldName: string) => {
    let newValue = false;

    if (fieldName === "bReasonCode") {
      newValue = approvalData && approvalData.hasOwnProperty("bReasonCode")
        ? !approvalData.bReasonCode
        : approvalData && !approvalData.hasOwnProperty("bReasonCode")
        ? true
        : false;
    }
    else if (fieldName === "bEmailNotifications") {
      newValue = !emailNotifications;
      setEmailNotifications(newValue);
    }

    const newParsedData = updateWorkflowBuilderValue(
      parsedData,
      uniqueId,
      fieldName,
      newValue,
      "replace"
    );

    setParsedData(newParsedData);

    let newReferenceData = _.cloneDeep(referenceData);

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.APPROVALS,
      "workflowApprovalsID",
      itemData.nodeApprovalId ?? null,
      fieldName,
      newValue,
      "replace"
    );

    setReferenceData(newReferenceData);
  };

  const textareaRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  const handleApprovalOutcomeValueChange = (
    fieldName: string,
    newValue: any,
    idx: number,
    operation: "replace" | "create"
  ) => {
    let newReferenceData = _.cloneDeep(referenceData);

    const approvalOutcomeId =
      approvalOutcomes &&
      approvalOutcomes[idx] &&
      approvalOutcomes[idx].workflowApprovalOutcomesID
        ? approvalOutcomes[idx].workflowApprovalOutcomesID
        : null;

    newReferenceData = changeWorkflowBuilderReferenceData(
      newReferenceData,
      WorkflowReferenceDataNames.APPROVAL_OUTCOMES,
      "workflowApprovalOutcomesID",
      approvalOutcomeId ?? null,
      fieldName,
      newValue,
      operation
    );

    setReferenceData(newReferenceData);
  };

  return (
    <div
      className={`ApprovalDecision DetailsItemContent ${
        relevantErrors && relevantErrors.length > 0 ? "Error" : ""
      }`}
    >
      <div className="Title">
        <div className="Text">Approval decision</div>

        <div
          className="EditApproval"
          onClick={() => setShowApprovalEditBox(true)}
        >
          {/* {...bind} */}
          <img src={editIcon} alt="Edit type" className="EditApprovalIcon" />
        </div>
      </div>

      {/* <div className="Row"> */}
      <div className="Label">Message</div>

      <textarea
        ref={textareaRef}
        placeholder="Type your text here"
        onChange={e => setMessage(e.target.value)}
        onBlur={messageOnBlur}
        value={message ?? ""}
        className="ApprovalMessage"
      />
      {/* </div> */}

      <div className="DecisionOutcomes">
        {approvalOutcomes &&
          approvalOutcomes.map((item: any, idx: number) => {
            return (
              <div
                className="DecisionOutcomeItem"
                key={`approval-outcome-decision-item-${uniqueId}-${idx}`}
              >
                <div
                  className="Row"
                  key={`approval-outcome-decision-item-row-${uniqueId}-${idx}`}
                >
                  <div
                    className="Label"
                    key={`approval-outcome-decision-item-label-${uniqueId}-${idx}`}
                  >{`Decision outcome ${idx + 1}:`}</div>

                  <input
                    key={`approval-outcome-decision-item-input-${uniqueId}-${idx}`}
                    type="text"
                    placeholder="Type your text here"
                    onChange={e => {
                      let newApprovalOutcomes = [...approvalOutcomes];

                      newApprovalOutcomes[idx].workflowApprovalOutcomesName =
                        e.target.value;

                      setApprovalOutcomes(newApprovalOutcomes);
                    }}
                    onBlur={() => decisionOutcomeOnBlur(idx)}
                    value={(item && item.workflowApprovalOutcomesName) ?? ""}
                  />

                  <DeleteApproval
                    approvalId={approvalData.workflowApprovalsID}
                    approvalOutcomeIds={[item.workflowApprovalOutcomesID]}
                    deleteApprovalOutcomes={deleteApprovalOutcomes}
                  />
                </div>

                <div className="Row SubRow">
                  <div className="SubLabel">Reason code for rejection:</div>

                  <div
                    className="Radio"
                    role="radio"
                    aria-checked={approvalData && approvalData.bReasonCode}
                  >
                    <input
                      id={`bReasonCodeCheckbox-${uniqueId}-${idx}`}
                      type="radio"
                      name={`bReasonCodeCheckbox-${uniqueId}-${idx}`}
                      value={`bReasonCode-${uniqueId}-${idx}}`}
                      onClick={() => {
                        if (item.hasOwnProperty("bReasonCode")) {
                          handleApprovalOutcomeValueChange(
                            "bReasonCode",
                            !item.bReasonCode,
                            idx,
                            "replace"
                          );
                        } else {
                          handleApprovalOutcomeValueChange(
                            "bReasonCode",
                            !item.bReasonCode,
                            idx,
                            "create"
                          );
                        }
                      }}
                      checked={item.bReasonCode}
                    />
                    <label
                      className="CustomInput"
                      htmlFor={`bReasonCodeCheckbox-${uniqueId}-${idx}`}
                    ></label>
                  </div>
                </div>
              </div>
            );
          })}

        <div
          className={`AddDecisionOutcome Btn ${
            approvalOutcomes && approvalOutcomes.length >= 5 ? "Disabled" : ""
          }`}
          onClick={handleAddDecisionOutcome}
        >
          <div className="Text">Add decision outcome</div>

          {/* <img src={addButton} alt="Add decision outcome" /> */}

          <div className="AddIconLineOne"></div>
          <div className="AddIconLineTwo"></div>
        </div>
      </div>

      {/* Note: should be 2 fields, multi select contact types and single select user pool, validation requires either one or more contact types or one user pool: */}
      <div className="Row">
        <div className="Label">Contact types</div>

        <MultiDropdown
          customClassName="MultiDropdown"
          onChange={(e: any) =>
            handleDropdownChangeMulti(e, "approvalContactTypesIDs")
          }
          value={
            contactTypes &&
            Array.isArray(contactTypes) &&
            approvalData &&
            approvalData.approvalContactTypesIDs &&
            Array.isArray(approvalData.approvalContactTypesIDs)
              ? contactTypes.filter(item =>
                  approvalData.approvalContactTypesIDs.includes(item.value)
                )
              : null
          }
          options={contactTypes}
          roundedRectangle
          portalMode={true}
        />
      </div>

      <div className="Row">
        <div className="Label">Userpool</div>

        <Dropdown
          onChange={(e: any) =>
            handleDropdownChangeSingle(e, "approvalUserPoolsID")
          }
          value={
            userPools &&
            Array.isArray(userPools) &&
            approvalData &&
            approvalData.approvalUserPoolsID &&
            typeof approvalData.approvalUserPoolsID === "number" &&
            userPools.filter(
              item => approvalData.approvalUserPoolsID === item.value
            ).length === 1
              ? userPools.filter(
                  item => approvalData.approvalUserPoolsID === item.value
                )[0]
              : null
          }
          options={userPools}
          roundedRectangle
          portalMode={true}
          isClearable={true}
        />
      </div>

      <div className="Row">
        <div className="Label">Email notifications</div>

        <div
          className="Radio"
          role="radio"
          aria-checked={emailNotifications}
        >
          <input
            id={`bEmailNotificationsCheckbox-${uniqueId}`}
            type="radio"
            name={`bEmailNotificationsCheckbox-${uniqueId}`}
            value="bEmailNotifications"
            onClick={() => handleBooleanChange("bEmailNotifications")}
            checked={emailNotifications}
          />
          <label
            className="CustomInput"
            htmlFor={`bEmailNotificationsCheckbox-${uniqueId}`}
          ></label>
        </div>
      </div>

      {relevantErrors && relevantErrors.length > 0 && (
        <div className="Errors">
          {relevantErrors.map(error => {
            return <div className="Error">{error}</div>;
          })}
        </div>
      )}
    </div>
  );
};

export default ApprovalDecision;
